import { apiUrl } from '../config/api';

/**
 * Holt alle Nutzer vom Backend
 */
export async function fetchAllUsers(token: string) {
  const res = await fetch(apiUrl('/api/users'), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!res.ok) {
    throw new Error('Fehler beim Laden der Nutzer');
  }

  return res.json();
}
